import React from 'react';
import { Container, Grid } from '@mui/material';
import {
  Public as PublicIcon,
  ManageAccounts as ManageAccountsIcon,
} from '@mui/icons-material';
import { brandColors } from '@horwath-htl/shared-branding';
import { useCurrentUser } from '../hooks/useApi';
import { useUserPermissions } from '../hooks/useUserPermissions';
import { HeroSection } from '../components/dashboard/HeroSection';
import { ApplicationCard } from '../components/dashboard/ApplicationCard';
import { EmptyState } from '../components/dashboard/EmptyState';

export const DashboardPage: React.FC = () => {
  const { data: currentUser, isLoading: isLoadingUser } = useCurrentUser();
  const { hasPermission, isLoading: isLoadingPermissions } = useUserPermissions();
  
  const isLoading = isLoadingUser || isLoadingPermissions;

  // Check if user has any permissions
  const hasAnyApplicationAccess = 
    hasPermission('store.view') ||
    hasPermission('market_compass.view') ||
    hasPermission('market_compass.admin');

  // Mock stats - in a real implementation, these would come from API calls
  const globalReportsStats = { label: 'Markets Covered', value: 45 };
  const adminStats = { label: 'Reports Managed', value: 127 };

  return (
    <Container maxWidth="xl" sx={{ pb: 4 }}>
      {/* Hero Section */}
      <HeroSection user={currentUser} />
      
      {/* Application Cards */}
      {hasAnyApplicationAccess ? (
        <Grid container spacing={4}>
          {hasPermission('store.view') && (
            <Grid item xs={12} md={6}>
              <ApplicationCard
                title="Global MarketCompass Reports"
                subtitle="Premium Market Intelligence"
                description="Browse and purchase premium MarketCompass reports covering global hospitality markets"
                icon={<PublicIcon />}
                color={brandColors.gold}
                link="/global-market-reports"
                stats={globalReportsStats}
                delay={100}
              />
            </Grid>
          )}
          {hasPermission('market_compass.admin') && (
            <Grid item xs={12} md={6}>
              <ApplicationCard
                title="Manage MarketCompass"
                subtitle="Administrative Controls"
                description="Upload reports, manage content, and configure MarketCompass settings"
                icon={<ManageAccountsIcon />}
                color={brandColors.error}
                link="/admin/market-compass"
                stats={adminStats}
                isAdmin={true}
                delay={300}
              />
            </Grid>
          )}
        </Grid>
      ) : (
        <EmptyState isLoading={isLoading} />
      )}
    </Container>
  );
};
